import $ from 'jquery';

if ($('.mw_wp_form_preview').length) {
  if ($('input[name="question"]').val() === '採用に関するお問い合わせ') {
    $('input[name="company"]').parents('.c-form1__item').remove();
    $('input[name="company_furigana"]').parents('.c-form1__item').remove();
  }
}
